<template>
	<div>
		<v-layout row wrap justify-end align-center class="header-booking-data">
			<amounts-component :subsidiary-id="params.idSubsidiary" />
			<v-flex xs2>
				<v-select
					class="filter-select"
					hide-details
					:items="subsidiaries"
					item-text="name"
					item-value="id"
					single-line
					v-model="params.idSubsidiary"
					@input="onChangeSubsidiary"
				>
				</v-select>
			</v-flex>
		</v-layout>
		<v-layout row wrap justify-center align-center mb-3>
			<v-flex xs10 pr-2>
				<v-layout row wrap justify-center py-2
					align-center class="bar-information">
					<v-flex xs2>
						<v-layout row wrap align-center justify-center>
							<v-flex xs2 pr-2 class="border-right">
								<img :src="`${$imageS3}/clerkinn/key-icon.svg`" alt="">
							</v-flex>
							<v-flex xs9 text-xs-left pl-2>
								<label class="bar-label">
									Habitaciones:
								</label>
								<span class="bar-text">{{ dashboard.numRooms }}</span>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs2>
						<v-layout row wrap align-center justify-center>
							<v-flex xs3 class="border-right">
								<img :src="`${$imageS3}/clerkinn/cancel-icon.svg`" alt="">
							</v-flex>
							<v-flex xs9 text-xs-left pl-2>
								<label class="bar-label">
									Inactivas:
								</label>
								<span class="bar-text">{{ dashboard.lockedRooms }}</span>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs2>
						<v-layout row wrap align-center justify-center>
							<v-flex xs3 class="border-right">
								<img :src="`${$imageS3}/clerkinn/adult-icon.svg`" alt="">
							</v-flex>
							<v-flex xs9 text-xs-left pl-2>
								<label class="bar-label">
									Adultos:
								</label>
								<span class="bar-text">{{ dashboard.adults }}</span>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs2>
						<v-layout row wrap align-center justify-center>
							<v-flex xs3 class="border-right">
								<img :src="`${$imageS3}/clerkinn/child-icon.svg`" alt="">
							</v-flex>
							<v-flex xs9 text-xs-left pl-2>
								<label class="bar-label">
									Niños:
								</label>
								<span class="bar-text">{{ dashboard.childrens }}</span>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs4>
						<v-layout row wrap align-center justify-center>
							<v-flex xs2 class="border-right">
								<img :src="`${$imageS3}/clerkinn/calendar-icon.svg`" alt="">
							</v-flex>
							<v-flex xs9>
								<label class="bar-label">
									Fecha:
								</label>
								<span class="bar-text">{{ dashboard.date }}</span>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs2 pl-2>
				<v-layout row wrap justify-center py-1
					align-center class="bar-information">
					<v-flex xs12 px-2>
						<v-select
							hide-details
							placeholder="Tipo de Habitación"
							class="filter-select type-room-select"
							:items="roomsTypes"
							item-text="name"
							item-value="id"
							v-model="params.roomTypeId"
							@input="loadData"
						/>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-layout row wrap justify-start align-center mb-3>
			<v-flex xs4>
				<v-card height="259px" class="pa-2">
					<v-layout row wrap align-center mb-2>
						<v-flex xs8 text-xs-left>
							<label class="bar-label">
								Caja:
							</label>
						</v-flex>
						<v-flex xs4 text-xs-right pl-4>
							<v-select
								class="filter-select filter-select-slot"
								:items="currencies"
								v-model="params.currency"
								item-text="code"
								item-value="code"
								max-height="auto"
								hide-details
								@input="loadAmounts"
							>
								<template slot="selection" scope="data">
									<v-avatar>
										<img :src="data.item.img">
									</v-avatar>
									{{ data.item.code }}
								</template>
								<template slot="item" scope="data">
									<v-list-tile-avatar>
										<img :src="data.item.img"/>
									</v-list-tile-avatar>
									<v-list-tile-content>
										<v-list-tile-title v-html="data.item.code"></v-list-tile-title>
									</v-list-tile-content>
								</template>
							</v-select>
						</v-flex>
					</v-layout>
					<v-layout wrap align-center class="categories-container">
						<span v-if="isLoading" class="loading">Cargando...</span>
						<v-flex
							v-else
							xs12
							v-for="(category, categoryIndex) in amounts"
							:key="category.id">
							<v-layout wrap align-center>
								<v-flex xs4 py-0 text-xs-left>
									<p class="category-name">{{ category.name }}</p>
								</v-flex>
								<v-flex xs5 pa-0>
									<v-progress-linear
										:value="category.percentage"
										height="3"
										:color-front="category.color"
										color-back="grey"
										class="my-0"
									></v-progress-linear>
								</v-flex>
								<v-flex xs3 pl-0 py-0 text-xs-right>
									<p class="category-name">
										{{ params.currency }} {{ category.amount | round }}
									</p>
								</v-flex>
								<v-flex xs12 py-0 v-if="categoryIndex < (amounts.length - 1)">
									<v-divider></v-divider>
								</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
					<v-layout wrap align-end justify-end px-1>
						<v-flex xs12 pa-0>
							<v-divider></v-divider>
						</v-flex>
						<p class="category-total">
							{{ params.currency }} {{ totalAmount | round }}
						</p>
					</v-layout>
				</v-card>
			</v-flex>
			<v-flex xs8>
				<v-card height="259px" class="pa-2">
					<v-layout row wrap align-center>
						<v-flex xs12 text-xs-left>
							<label class="bar-label">
								Estados:
							</label>
						</v-flex>
					</v-layout>
					<v-layout row wrap align-center px-1>
						<state-box
							v-for="(state, indexState) in dashboard.states"
							:key="indexState"
							:state="state"
						/>
					</v-layout>
				</v-card>
			</v-flex>
			<v-flex xs4>
				<v-card height="auto" class="pa-2">
					<v-layout row wrap align-center>
						<v-flex xs12 text-xs-left>
							<label class="bar-label">
								Disponibilidad del día:
							</label>
						</v-flex>
					</v-layout>
					<v-layout row wrap align-center>
						<v-flex xs12 class="position-relative">
							<vue-chart
								type="doughnut"
								:data="chartDataAvailability"
								:options="optionsChartAvailability"
							></vue-chart>
							<div class="total-amount">
								<span>{{ dashboard.availability.percent.name }}</span>
								<p>{{ dashboard.availability.percent.value }}%</p>
							</div>
						</v-flex>
					</v-layout>
				</v-card>
			</v-flex>
			<v-flex xs8>
				<v-card height="232" class="pa-2 customers-card">
					<v-layout row wrap align-center>
						<v-flex xs12 text-xs-left>
							<label class="bar-label">
								Cuentas por cobrar:
							</label>
						</v-flex>
					</v-layout>
					<v-layout row wrap align-center px-1>
						<v-flex class="customers-table">
							<table-run
								:columns="columns"
								:rows="rows"
								:include-delete="false"
								:include-export-to-excel="false"
								:include-options="false"
								:include-settings="false"
								:include-switch="false"
								:include-search="false"
								:selectable="false"
							>
								<template slot="rows" scope="props">
									<td>{{ props.row.rzSocial }}</td>
									<td>{{ getChannel(props.row) }}</td>
									<td>{{ props.row.email }}</td>
									<td>{{ getEmployee(props.row) }}</td>
									<td>{{ props.row.numReserve }}</td>
									<td>{{ props.row.amountPayment }}</td>
									<td :class="{ 'red-color-amount': majorCero(props.row) }">
										{{ props.row.pendingAmount }}
									</td>
								</template>
							</table-run>
						</v-flex>
					</v-layout>
				</v-card>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs12>
				<v-card>
					<v-layout row wrap align-center>
						<v-flex xs6 text-xs-left pl-3>
							<label class="bar-label">
								Estados de habitaciones
							</label>
						</v-flex>
						<v-flex xs11 text-xs-left pl-5>
							<v-layout align-center justify-end class="bar-caption">
									<button  
										@click="updateDashboard(status.id)"
										v-for="(status, indexState) in status" 
										:key="indexState" 
										class="btn-state" 
										v-if="status.name === 'Check In' || status.name === 'Pendientes' || status.name === 'Check Out' || status.name === 'In House' || status.name === 'No-show' || status.name === 'Reservas'">
										<label class="bar-caption-text">
											<span class="bar-caption-color booking" :style="`background-color: ${status.colors}`"></span>
											{{status.name}}
										</label>
										<img 
										:src="`${$imageS3}${status.img}`" 
										v-if="!reservationState"
										>
										<span class="bar-caption-icon booking" :style="`background-color: ${status.colors}`" v-else>
											R
										</span>
									</button>
							</v-layout>
						</v-flex>
						<v-flex xs12>
							<v-layout row wrap align-center>
								<housekeeping-card
									v-for="booking in bookings"
									:key="booking.id"
									:flag-observed="booking.flagObserved"
									:room-number="booking.roomNumber" 
									:room-type-code="booking.roomTypeCode"
									:lastname="booking.customerLastname"
									:name="booking.customerName"
									:start-date="booking.bookingStart"
									:end-date="booking.bookingEnd"
									:currency="booking.currency"
									:booking-total="booking.total"
									:booking-color="booking.color"
									:booking-state="booking.bookingState"
									:href="booking.href" />
							</v-layout>
						</v-flex>
					</v-layout>
				</v-card>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	import { format } from 'date-fns';
	import esLocale from 'date-fns/locale/es';
	import VueChart from 'vuechart';
	import TableRun from 'table-run';
	import { round } from '@/shared/filters';
	import helper from '@/shared/helper';
	import mixin from '@/shared/mixins';
	import actionBar from '@/components/shared/actionBar/action-bar';
	import amountsComponent from '@/components/shared/AmountsComponent';
	import HousekeepingCard from '@/components/shared/HousekeepingCard';
	import StateBox from '@/components/shared/StateBox';

	const helperData = helper.data();

	function reservationState() {
		return this.bookingState === 1;
	}

	function created() {
		this.getStatus();
		this.loadHotel();
		this.loadCustomers();
		setInterval(this.clock, 1000);
	}

	function clock() {
		this.time = format(new Date(), 'HH:mm:ss');
	}

	async function updateDashboard(id) {
		this.loadBookings(id);
	}

	function filterDashboard(id) {
		this.currentType = id;
		const filterDashboards = this.bookings.filter(filterDas => filterDas.id) === this.currentType;
		return filterDashboards;
	}

	async function getStatus() {
		const { data: status } = await this.$http.get(`${process.env.PMS_URL}/booking/status`);
		this.status = status.data.map((element) => {
			const newStatus = { ...element };
			const image = this.imageStatus.find(c => c.id === element.id);
			if (image) {
				newStatus.img = image.img;
			}
			return newStatus;
		});
	}
	
	async function loadBookings(id) {
		let url;
		if (id) { url = `dashboard?bookingState=${id}`; } else { url = 'dashboard'; }
		const { data: bookings } = await this.$http.get(`${process.env.PMS_URL}/${url}`,
			{ params: this.params });
		this.bookings = bookings.data.map((book) => {
			const newBook = { ...book };
			newBook.flagObserved = book.flagObserved;
			newBook.roomNumber = Number(book.bookingRooms.data.codeRoom);
			newBook.customerLastname = book.customer ? book.customer.data.lastname
				: book.summary.personalInformation.lastName;
			newBook.customerName = book.customer ? book.customer.data.name
				: book.summary.personalInformation.name;
			newBook.currency = book.summary.promotion.iso_currency;
			newBook.bookingState = Number(book.bookingState);
			newBook.roomTypeCode = book.bookingRooms && book.bookingRooms.data
				&& book.bookingRooms.data.roomTypes && book.bookingRooms.data.roomTypes.data
				? book.bookingRooms.data.roomTypes.data.codeRoomtype : '';
			const active = Number(book.bookingState) > 1 && Number(book.bookingState) !== 4 ?
				'tab-2' : '';
			newBook.href = {
				name: 'checkin-form-tabs',
				params: {
					hotelId: this.params.idSubsidiary,
					roomTypeId: book.entityId,
				},
				query: {
					initDate: format(book.bookingStart, 'YYYY-MM-DD'),
					endDate: format(book.bookingEnd, 'YYYY-MM-DD'),
					roomId: book.bookingRooms.data.id,
					bookingCode: book.code,
					flagObserved: book.flagObserved,
					active,
				},
			};
			return newBook;
		});
	}

	async function loadData() {
		const { data: dashboard } = await this.$http.get(`${process.env.PMS_URL}/dashboard-availability`,
			{ params: this.params });
		dashboard.date = format(new Date(), 'DD MMMM YYYY', { locale: esLocale });
		const percent = dashboard.availability.percent.value;
		dashboard.availability.percent.value = percent % 1 === 0 ? percent : percent.toFixed(2);
		this.dashboard = dashboard;
		this.chartDataAvailability = {
			datasets: [{
				data: [],
				backgroundColor: [],
			}],
			labels: [],
		};
		dashboard.availability.values.forEach((val) => {
			this.chartDataAvailability.datasets[0].data.push(val.value);
			this.chartDataAvailability.datasets[0].backgroundColor.push(val.color);
			this.chartDataAvailability.labels.push(`${val.name}: ${val.value}`);
		});
		this.loadBookings();
	}

	async function loadAmounts() {
		this.isLoading = true;
		const url = `${process.env.PMS_URL}/categories-products`;
		const params = {
			date: this.params.date,
			currency: this.params.currency,
			idSubsidiary: this.params.idSubsidiary,
		};
		const { data: amounts } = await this.$http.get(
			url,
			{ params });
		this.amounts = amounts;
		this.chartData.datasets[0].data = this.amounts.map((amount) => {
			const newAmount = { ...amount };
			newAmount.amount = Number(amount.amount);
			return newAmount.amount;
		});
		this.chartData.datasets[0].backgroundColor = this.amounts.map((amount) => {
			const newAmount = { ...amount };
			newAmount.color = amount.color || this.randomColor();
			return newAmount.color;
		});
		this.chartData.labels = this.amounts.map((amount) => {
			const newAmount = { ...amount };
			newAmount.caption = `${amount.name}: USD${amount.amount}`;
			return newAmount.caption;
		});
		this.isLoading = false;
	}

	async function loadHotel() {
		const { data: subsidiaries } = await this.$http.get(`${process.env.PMS_URL}/hotel`);
		this.subsidiaries = subsidiaries.data;
		this.params.idSubsidiary = this.subsidiaries[0].id;
	}

	function onChangeSubsidiary() {
		this.params.roomTypeId = null;
		this.loadAmounts();
		this.loadBookings();
		this.loadRooms();
		this.loadData();
	}

	async function loadRooms() {
		const id = this.params.idSubsidiary;
		const url = `${process.env.PMS_URL}/roomtype/${id}`;
		const { data: roomsTypes } = await this.$http.get(url);
		this.roomsTypes = roomsTypes.data;
	}

	function randomColor() {
		const color = Math.floor(Math.random() * 16777215).toString(16);
		return `#${color}`;
	}

	function runAction({ codeWeb }) {
		this.$router.push({ name: codeWeb });
	}

	function totalAmount() {
		return this.amounts.reduce((acum, amount) => (acum + amount.amount), 0);
	}

	async function loadCustomers(page = 1) {
		this.customersParams.page = page;
		const { data: response } = await this.$http.get(
			`${process.env.PMS_URL}/customers-commercial-type`,
			{ params: this.customersParams },
		);
		this.rows = response.data;
		if (this.rows.length === 0) {
			this.showNotification('No se encontraron clientes registrados.', 'info');
		}
	}

	function getChannel({ channel }) {
		return channel ? `${channel.data.name}` : null;
	}

	function getEmployee({ employee }) {
		return employee ? `${employee.data.name} ${employee.data.lastname}` : null;
	}

	function majorCero({ pendingAmount }) {
		return pendingAmount > 0;
	}

	function data() {
		return {
			imageStatus: [
				{
					id: 7,
					img: '/clerkinn/in-house-icon.svg',
				},
				{
					id: 6,
					img: '/clerkinn/no-show-icon.svg',
				},
				{
					id: 2,
					img: '/clerkinn/checkin-icon.svg',
				},
				{
					id: 3,
					img: '/clerkinn/checkout-icon.svg',
				},
				{
					id: 1,
					img: '/clerkinn/img-reservada.png',
				},
			],
			amounts: [],
			currentType: '',
			bookings: [],
			chartData: {
				datasets: [{
					data: [],
					backgroundColor: [],
				}],
				labels: [],
			},
			chartDataAvailability: {
				datasets: [{
					data: [],
					backgroundColor: [],
				}],
				labels: [],
			},
			columns: [
				{ id: 1, name: 'Nombre completo', code: 'fullName' },
				{ id: 2, name: 'Tipo', code: 'type' },
				{ id: 3, name: 'Email', code: 'email' },
				{ id: 4, name: 'Vendedor', code: 'employee' },
				{ id: 5, name: 'Reservas', code: 'numReserve' },
				{ id: 6, name: 'Gasto Total', code: 'amountPayment' },
				{ id: 7, name: 'Cuentas por cobrar', code: 'pendingAmount' },
			],
			currencies: [
				{
					id: 1,
					code: 'USD',
					img: helperData.flagEn,
				},
				{
					id: 2,
					code: 'PEN',
					img: helperData.flagPe,
				},
			],
			dashboard: {
				availability: {
					percent: {},
					values: [],
				},
				states: [],
			},
			isLoading: false,
			optionsChart: {
				cutoutPercentage: 60,
				legend: {
					labels: {
						boxWidth: 10,
						fontColor: '#818181',
						fontSize: 9,
					},
					position: 'bottom',
				},
				tooltips: {
					enabled: false,
				},
			},
			optionsChartAvailability: {
				cutoutPercentage: 60,
				legend: {
					labels: {
						boxWidth: 10,
						fontColor: '#818181',
					},
					position: 'bottom',
				},
				tooltips: {
					enabled: false,
				},
			},
			params: {
				date: format(new Date(), 'YYYY-MM-DD'),
				idSubsidiary: 0,
				currency: 'USD',
			},
			customersParams: {
				page: 1,
				perPage: 100,
				sortDirection: null,
				sortField: null,
			},
			roomsTypes: [],
			rows: [],
			subsidiaries: [],
			status: [],
			time: 0,
		};
	}

	export default {
		name: 'dashboard-clerkinn-main',
		components: {
			actionBar,
			amountsComponent,
			HousekeepingCard,
			StateBox,
			TableRun,
			[VueChart.name]: VueChart,
		},
		computed: {
			reservationState,
			totalAmount,
			filterDashboard,
		},
		created,
		data,
		filters: {
			round,
		},
		methods: {
			updateDashboard,
			getStatus,
			clock,
			getChannel,
			getEmployee,
			loadAmounts,
			loadBookings,
			loadCustomers,
			loadData,
			loadHotel,
			loadRooms,
			onChangeSubsidiary,
			majorCero,
			randomColor,
			runAction,
		},
		mixins: mixin,
	};
</script>

<style lang="scss" scoped>
	.btn-state {
		cursor: !important  pointer;
		margin: 8px;
	}
	.header-booking-data {
		height: 31px;
		position: absolute;
		right: 20px;
		text-align: right;
		top: 52px;
		width: calc(100% - 230px);

		&-calendar {
			margin: 0px !important;
			position: static;
			width: 100%;
		}

		div {
			padding-bottom: 0px !important;
			padding-top: 0px !important;
		}

		p {
			color: map-get($colors, blue-title);
			font-family: map-get($fonts, regular);
			font-size: 10px;
			margin: 0px;
			text-transform: uppercase;
		}

		span {
			color: map-get($colors, default-skyblue);
			font-family: map-get($fonts, medium);
			font-size: 15px;
		}

		.border-select {
			border-right: 1px solid map-get($colors, border-radio);
			margin-right: 16px;
			padding-right: 16px !important;
		}
	}

	.bar {
		&-information {
			background-color: white;

			.border-right {
				border-right: 1px solid map-get($map: $colors, $key: year-select);
			}

			img {
				vertical-align: middle;
			}
		}

		&-label {
			color: map-get($map: $colors, $key: bg-chart);
			font-family: map-get($map: $fonts, $key: medium);
		}

		&-text {
			color: map-get($map: $colors, $key: realtime-label);
			text-transform: capitalize;
		}

		&-watch {
			border: 1px solid map-get($map: $colors, $key: border-radio);
			border-radius: 7px;
			height: 28.7px;

			&-time {
				color: map-get($map: $colors, $key: color-selected-item);
				font-family: map-get($map: $fonts, $key: medium);
				font-size: map-get($map: $sizes, $key: fifteen);
			}
		}
	}

	.card {
		min-height: 231px;
	}

	.total-amount {
		align-content: flex-end;
		bottom: 0;
		color: map-get($map: $colors, $key: color-selected-item);
		display: flex;
		flex-wrap: wrap;
		font-family: map-get($map: $fonts, $key: medium);
		height: 0px;
		justify-content: center;
		left: 0;
		margin: auto;
		position: absolute;
		right: 0;
		top: 10%;

		span {
			flex-basis: 18%;
			font-size: map-get($map: $sizes, $key: ten);
			line-height: 1;
		}

		p {
			flex-basis: 100%;
			font-size: 26px;
			margin: 0px;
			line-height: 1;
		}
	}

	.position-relative {
		position: relative;
		min-height: calc(100vw / 15);
	}

	.bar-caption {
		&-color {
			border-radius: 2px;
			display: inline-block;
			height: 8px;
			margin-right: 6px;
			vertical-align: middle;
			width: 8px;

			&.no-show {
				background-color: map-get($colors, locked);
			}

			&.checkin {
				background-color: map-get($colors, check-in);
			}

			&.checkout {
				background-color: map-get($colors, check-out);
			}

			&.booking {
				background-color: map-get($colors, booking);
			}

			&.in-house {
				background-color: map-get($colors, in-house);
			}
		}

		&-icon.booking {
			background-color: map-get($colors, booking);
			border-radius: 50%;
			color: map-get($colors, white);
			display: inline-block;
			height: 14px;
			line-height: 14px;
			text-align: center;
			width: 14px;
		}

		&-icon img {
			vertical-align: middle;
		}

		&-text {
			color: map-get($map: $colors, $key: realtime-label);
			vertical-align: middle;
		}
	}

	.category-name {
		color: map-get($colors, realtime-label);
		font-size: map-get($sizes, twelve);
		margin: 0px;
	}

	.category-total {
		color: map-get($colors, realtime-label);
		font-family: map-get($fonts, bold);
		font-size: map-get($sizes, fourteen);
		margin: 0px;
	}

	.categories-container {
		height: 170px;
		overflow: auto;
	}

	.customers-card {
    	max-height: 231px;
		overflow: hidden;
	}

	.customers-table {
    	height: 190px;
		overflow: auto;
	}

	.loading {
		font-size: map-get($sizes, breadcrumb);
		text-align: center;
		width: 100%;
	}

</style>


// WEBPACK FOOTER //
// Dashboard.vue?814587d6